import React from 'react'

import { BottomSheet, Button } from '@s4l/ds'
import { IconInfo } from '@s4l/icons/IconInfo'
import { Board } from '@s4l/stayforlong/booking/Board'
import { Rate } from '@s4l/stayforlong/booking/Rate'

import BoardInfo from './BoardInfo'
import PaymentAndCancellationInfo from './PaymentAndCancellationInfo'

interface IInfoProps {
  model: Rate | Board
}

function Info({ model }: Readonly<IInfoProps>) {
  if (model instanceof Board && model.isRoomOnly()) return null

  return (
    <BottomSheet>
      <BottomSheet.Trigger asChild>
        <Button variant="icon-flat" size="extraSmall" leadingIcon={<IconInfo />} />
      </BottomSheet.Trigger>
      {model instanceof Rate && <PaymentAndCancellationInfo model={model} />}
      {model instanceof Board && <BoardInfo model={model} />}
    </BottomSheet>
  )
}

Info.displayName = 'RoomConfigurator.Form.Info'

export default Info
